import { useEffect, useState } from 'react';

import { authStore, type DashboardAuth } from '../../auth/authStore';

export const readDashboardAccountScope = (auth: DashboardAuth | null = authStore.getAuth()): string => {
  if (auth === null) return 'signed-out';

  return JSON.stringify([auth.role, auth.brokerageId, auth.agentId, auth.token]);
};

export const useDashboardAccountScope = (): string => {
  const [scope, setScope] = useState(() => readDashboardAccountScope());

  useEffect(() => authStore.subscribe(auth => setScope(readDashboardAccountScope(auth))), []);

  return scope;
};
